import { render, staticRenderFns } from "./PlayerUnban.vue?vue&type=template&id=0d89660e&"
import script from "./PlayerUnban.vue?vue&type=script&lang=js&"
export * from "./PlayerUnban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports